/**
 * Param get list recoil
 */

// Recoil
import { atom } from 'recoil';

// Utils
import { IParamGetList } from 'models/UserRequest';
import { ParamsGetListSetting } from 'utils/constants';

export const paramsGetListAtom = atom<IParamGetList>({
  key: 'paramsGetListsAtom',
  default: {
    order_by: ParamsGetListSetting.ORDER_BY,
    page: ParamsGetListSetting.DEFAULT_PAGE as number,
    per_page: ParamsGetListSetting.ROW_PER_PAGE as number,
    sort_name: '',
    keyword: '',
  },
});
